// lang-fr.ts

export const LANG_FR_NAME = "fr";

export const LANG_FR_TRANS = {
  LblWeekdays: {
    shorthand: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
    longhand: [
        "Dimanche", 
        "Lundi", 
        "Mardi", 
        "Mercredi", 
        "Jeudi", 
        "Vendredi", 
        "Samedi"
    ]
  },
  LblMonths: {
    shorthand: [
        "Jan.",
        "Fév.",
        "Mars.",
        "Avr.",
        "Mai",
        "Juin",
        "Juil.",
        "Août",
        "Sep.",
        "Oct.",
        "Nov.",
        "Déc."
    ],
    longhand: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre"
    ]
  },
  LblButtonText: {
    today: "Aujourd'hui",
    month: "Mois",
    week: "Semaine",
    day: "Jour",
    list: "Liste"
  },
  LblEdit: "Modifier",
  LblDelete: "Supprimer",
  LblRemove: "Supprimer",
  LblActiveInactive: "Actif / Inactif",
  LblActive: "Actif",
  LblInactive: "Désactiver",
  LblAddNew: "Ajouter",
  LblAdd: "Ajouter",
  LblUpdate: "Modifier",
  LblSave: "Enregistrer",
  LblCancel: "Annuler",
  LblReset: "Réinitialiser",
  LblSelect: "Sélectionnez",
  LblSuccess: "Réussi",
  LblWarning: "Avertissement",
  LblList: "Liste",
  LblAssign: "Attribuer à",
  LblHome: "Accueil",
  LblYes: "Oui",
  LblOK: "Ok",
  LblNo: "Non",
  LblBack: "Revenir à la page précédente",
  LblReason: "Motif",
  LblRecordSavedSuccess: "Enregistrement réussi",
  LblRecordDeleteSuccess: "Suppression réussie",
  LblResetPasswordSuccess: "Mot de passe réinitialisé",
  LblBookingApproveRejectSuccess: "%0 %1 avec succès",
  LblRecordAddedSuccess: "%0 ajouté(s)",
  LblRecordUpdatedSuccess: "%0 modifié(s) avec succès",
  LblRecordRemovedSuccess: "0% supprimé(s)",
  LblRecordActiveInActiveSuccess: "%0 %1 réussi(s)",
  LblinvoiceResendSuccess: "%0 à nouveau envoyé(s)",
  LblRecordBlokUnBlockSuccess: "%0 %1 réussi(s)",
  LblConfirm: "Confirmer",
  LblContactPersonAddedSuccess: "Personne à contacter ajoutée",
  LblBlockUnblockConfirm: "Êtes-vous certain de vouloir %0 le %1 ?",
  LblRecordDeleteConfirmation: "Êtes-vous certain de vouloir supprimer %0 ?",
  LblRecordMultiplDeleteConfirmation: "Êtes-vous certain de vouloir supprimer la sélection ?",
  LblConfirmMessage: "Êtes-vous sûr ?",
  LblResetPassword: "Réinitialiser le mot de passe",
  LblResetPasswordConfirmation: "Êtes-vous certain de vouloir réinitialiser le mot de passe ?",
  LblGeoLocationError: "Saisissez une géolocalisation correcte",
  LblPersonDeleteCheck: "Supprimer définitivement",
  LblBookingCancelSuccess: "L'annulation des réservations a été effectuée avec succès",
  LblBookingAbortSuccess: "La réservation a bien été annulée",
  LblBookingRevokeSuccess: "La réservation a bien été supprimée",
  LblContactPersonRemoveSuccess: "Personne à contacter supprimée",
  LblNoRecords: "Aucune donnée disponible",
  LblAffectedBookingList: "Liste des réservations concernées",
  LblSubscriptionEndDateError: "Saisir la date de fin d'abonnement",
  LblIsSpecialPeriodAllow: "Souhaitez-vous appliquer des frais pour une période particulière ?",
  LblContractSlotisnotdefined: "Le type de contrat pour le créneau horaire indiqué ci-dessous n'est pas défini",
  LblUnscubscribeSuccess: "Désabonnement confirmé",
  LblModifiedBy: "Modifié par",
  LblModifiedDate: "Date de modification",
  LblInstance: "Organisme",
  LblInstanceName: "Nom de l'organisme",
  LblInstanceType: "Type d'organisme",
  LblDescription: "Description",
  LblCurrencySymbol: "Symbole de la devise monétaire",
  LblPreferredLanguage: "Langue",
  LblTimeZone: "Fuseau horaire",
  LblCurrencyAbbreviation: "Abréviation de la devise monétaire",
  LblInstanceDeleteValidation: "Impossible de supprimer l'instance car elle fait référence à une autre entité",
  LblIsBookingApprovalReq: "Autorisation de la réservation requise",
  LblKilometers: "Kilomètres",
  LblKM: "Km",
  LblDeletePersonNote: "Les factures en attente pour cette personne ne seront pas envoyées",
  LblInstanceConfiguration: "Configuration des services",
  LblBookingAlertTime: "Délai d'avertissement de réservation",
  LblBookingCancelTime: "Délai d'annulation de la réservation",
  LblBookingTemporaryTime: "Heure de confirmation de la réservation",
  LblVtsRequestTimeout: "Demande de VTS - aucune réaction",
  LblVtsTripLogTimeout: "Carnet de route VTS - aucune réaction",
  LblEmailConfiguration: "Configuration de la messagerie (SMTP)",
  LblInSeconds: "En secondes",
  LblFromEmail: "Envoyer l'adresse électronique",
  LblHost: "Hôte",
  LblPort: "Port",
  LblEnableSsl: "Activer SSL",
  LblSmtpEmail: "Courriel SMTP",
  LblIsImportPersonAllow: "Permission d'importer la personne",
  LblValidateLiceanceNumber: "Vérification du permis de conduire",
  LblValidateLicenseA2SP: "Vérification du permis de conduire A2SP",
  LblValidateLicense24IDCheck: "Vérification du permis de conduire 24ID",
  LblValidateLicenseForAllBookings: "Effectuer une vérification du permis de conduire pour chaque réservation",
  LblGeofenceLocation: "Location geofence",
  LblRadius: "Rayon",
  LblEmailRecepients: "Destinataires des courriels",
  LblRecepients: "Destinataires",
  LblEmailAddresses: "Adresses mail",
  LblMap: "Carte",

  // AFAS/Azure Config
  LblImportConfiguration: "Import Configuration",
  LblImportConnectionType: "Connection Type",
  LblAfas: "AFAS",
  LblAzure: "Azure",
  LblAzureTenantId: "Azure Tenant ID",
  LblAzureClientId: "Azure Client ID",
  LblAzureClientSecret: "Azure Client Secret",
  LblAfasClientId: "AFAS Client ID",
  LblAfasConnectorName: "AFAS Connector Name",
  LblAfasConnectionType: "AFAS Connection Type",
  LblAfasTest: "Test",
  LblAfasAccept: "Acceptation",
  LblAfasProduction: "Production",
  LblAfasToken: "AFAS Token",
  LblAfasClientIdError: "Please enter AFAS Client ID",
  LblAfasConnectorNameError: "Please enter AFAS Client ID",
  LblAfasConnectionTypeError: "Please enter AFAS Connection Type",
  LblAfasTokenError: "Please enter AFAS-Token",
  LblAzureTenantIdError: "Please enter Azure Tenant ID",
  LblAzureClientIdError: "Please enter Azure Client ID",
  LblAzureClientSecretError: "Please enter Azure Client Secret",

  // SSO Config
  LblSsoConfiguration: "SSO Configuration",
  LblDefaultSsoSharedVehicleGroup: "Default Shared Vehicle Group",
  LblDefaultSsoOrganization: "Default Organization",
  LblDefaultSsoSubscription: "Default Subscription",

  // Dropoff Message
  LblDropoffMessageConfiguration: "Dropoff Message Configuration",
  LblDropoffMessageExternalUrl: "External Url",
  LblDropoffMessageApiKey: "Api Key",
  LblDropoffMessageActive: "Active",

  LblBookingCalanderSettings: "Configuration de l'agenda",
  LblShowDriverInfo: "Afficher les données du conducteur dans l'agenda",
  LblOrganizationAdmin: "Gestionnaire de l'organisation",
  LblDriverInfoToShow: "Données du conducteur qui sont affichées",
  LblValidate: "Valider",
  LblBookingCancelTimeMessage: "Ceci définit le laps de temps (en secondes) après lequel l'annulation d'une réservation n'est plus possible",
  LblBookingTemporaryTimeMessage: "Temps pour une réservation provisoire. Après que l'utilisateur ait sélectionné le véhicule à réserver mais celui-ci n'a pas encore été confirmé.",
  LblVtSRequestTimeoutMessage: "Aucune réaction pour la commande de déverrouillage / verrouillage dans l'appli",
  LblVtsTriplogTimeoutMessage: "Aucune réaction pour le calcul des déplacements après exécution de la commande de verrouillage",
  LblContractTypeDeleteValidation: "Impossible de supprimer le Groupe de Type de Contrat car celui-ci est rattaché à une autre entité",
  LblUserName: "Nom d'utilisateur",
  LblFirstName: "Prénom",
  LblLastName: "Nom",
  LblEmail: "Adresse mail",
  LblMobileNumber: "Numéro de téléphone portable",
  LblPhoneNumber: "Numéro de téléphone",
  LblHomeAddress: "Adresse personnelle",
  LblWorkAddress: "Adresse professionnelle",
  LblHouseNo: "Numéro",
  LblHouseExtention: "Extension",
  LblStreetName: "Rue",
  LblCity: "Ville",
  LblZipCode: "Code postal",
  LblPassword: "Mot de passe",
  LblConfirmPassword: "Confirmez le mot de passe",
  LblMiddleName: "Particule",
  LblCompany: "Entreprise",
  LblCompanyName: "Nom de l'entreprise",
  LblContactPerson: "Personne à contacter",
  LblCompanyAdmin: "Administrateur de l'entreprise",
  LblCompanyAddress: "Adresse de l'entreprise",
  LblApkExiprationSetting: "Paramètres de notification CT",
  LblNotificationFrequency: "Fréquence de notification",
  lblThresholdFrequency: "Fréquence d'avertissement au préalable",
  lblThresholdTimeInterval: "À quelle fréquence les avertissements seront envoyés au préalable",
  LblIsEmailEnabled: "Message par mail",
  LblEnabled: "Activé",
  LblDisabled: "Désactivé",
  LblFrequency: "Fréquence",
  LblApkTimeInterval: "Intervalle de temps des avertissements",
  LblEmailNotification: "Message par mail",
  LblWeek: "SEMAINE",
  LblMonth: "Mois",
  lblPerBooking: "Par réservation",
  LblInternalOrganization: "Organisation interne",
  LblNoOfVegicles: "Nombre de véhicules",
  LblNoOfSharedVehicleGroups: "Nombre de groupes cibles",
  LblGeoLocation: "Site",
  LblSelectGeoLocation: "Sélectionnez un site",
  LblPerson: "Personne",
  LblRole: "Fonction",
  LblDateOfBirth: "Date de naissance",
  LblDriverLicenceNumber: "Numéro de permis de conduire",
  LblPersons: "Personnes",
  LblPersonOverview: "Aperçu de la ou des personnes",
  LblCompanies: "Entreprises",
  LblVehicle: "Véhicule",
  LblVtsVehicle: "Véhicule VTS",
  LblLicenceTag: "Plaque d'immatriculation",
  LblLicence: "Permis de conduire",
  LblMobile: "Téléphone portable",
  LblVehicleOwner: "Propriétaire du véhicule",
  LblLocationDataExchange: "Lieu d'échange de données",
  LblBrand: "Marque",
  LblType: "Type",
  LblColor: "Couleur",
  LblVehicleClass: "Catégorie de véhicule",
  LblPricingCategory: "Catégorie de prix",
  LblBodyStyle: "Type de carrosserie",
  LblAvailable: "Disponible",
  LblUnAvailable: "Indisponible",
  LblAvailableFrom: "Disponible à partir du",
  LblAvailableTo: "Disponible jusqu'au",
  LblFuelType: "Type de carburant",
  LblMinBookingTimeBefore: "Temps minimum avant la réservation (en minutes)",
  LblMinBookingTimeAfter: "Temps minimum après la réservation (en minutes)",
  LblTowbar: "Dispositif d'attelage",
  LblAirco: "Climatisation",
  LblApkExpirationDateCet: "Date d'expiration CT",
  LblVehicleAttributes: "Caractéristiques du véhicule",
  LblBlockUnBlock: "Bloquer / Débloquer",
  LblRemoveLicense: "Supprimer permis de conduire",
  LblRemoveLicenseBirthDate: "Supprimer permis de conduire et date de naissance",
  LblLicenseBirthDate: "Date de naissance",
  LblBlock: "Bloquer",
  LblUnblock: "Débloquer",
  LblAvailableUnAvailable: "Disponible / Indisponible",
  LblIntialOdometerValue: "Kilométrage de début",
  LblVehicles: "Véhicules",
  LblBookingsOverview: "Récapitulatif des réservations",
  LblFuelCardPinCode: "Code PIN pour la carte de carburant",


  
  LblFuel: "Carburant",
  LblVINnumber: "Numéro d'identification du véhicule",
  LblVehicletype: "Type de véhicule",
  LblDoors: "Nombre de portes",
  LblWeight: "Poids du véhicule",
  LblTrunkSpace: "Volume du coffre",
  LblGears: "Nombre de vitesses",
  LblEngineHorsepower: "Puissance moteur ",
  LblFuelConsumption: "Consommation de carburant",
  LblSeats: "Nombre de places",
  LblDimensions: "Dimensions du véhicule",
  LblTransmissionType: "Type de transmission",
  LblTransmissionUnknown: "Type de transmission inconnu",
  LblManualTransmission: "Transmission manuelle",
  LblAutomaticTransmission: "Transmission automatique",

  LblVehicleDetails: "Détails du véhicule",
  LblSelectVehicletype: "Sélectionnez le type de véhicule",
  LblWrongVinNumber: "Numéro d'identification non valide",


  LblVehicleOnSameLocationTime: "Véhicule au même endroit plus longtemps que",
  LblNoBookingIn: "Aucune réservation pour plus de",
  lblHour: "Heure",
  lblHourDayWeekMonth: "Heure / jour / semaine / mois",
  LblSharedVehicleGroup: "Groupe cible",
  LblVehicleGroup: "Groupe de véhicule",
  LblSharedVehicleGroupAdmin: "Administrateur du groupe de pool",
  LblDisplayPeriod: "Période d'affichage",
  LblBookingWeekDays: "Réserver des jours ouvrables",
  LblBookingInterval: "Intervalle de réservation (en minutes)",
  LblBookingStartTime: "Heure de début de la réservation (hh:mm)",
  LblBookingEndTime: "Heure de fin de la réservation (hh:mm)",
  LblBookingMinDuration: "Durée minimale de réservation (en minutes)",
  LblBookingMaxDuration: "Durée maximale de réservation (en minutes)",
  LblMaxRecurringBooking: "Nombre maximum de répétitions",
  LblPreBookingInterval: "Marge de temps avant la réservation (en minutes)",
  LblPostBookingInterval: "Marge de temps après la réservation (en minutes)",
  LblBookingExtensionTime: "Durée maximale d'extension de la réservation (en minutes)",
  LblBookAheadTime: "Réservation possible dans X minutes",
  LblBookingHorizon: "Horizon des réservations",
  LblDay: "Jour",
  LblNumberOfContactTypeGroup: "Nombre de groupes de types de contrats",
  LblNumberOfContactType: "Nombre de types de contrats",
  LblInvoiceInterval: "Intervalle de facturation",
  LblIsBookingIntervalAlignToCalendar: "Choix de l'heure de la réservation conforme au bloc horaire",
  LblEarlyOpenInterval: "Intervalle ouverture plus tôt (en minutes)",
  LblFeatureFlags: "Indicateurs de fonctionnalité",
  LblCreateBooking: "Créer une réservation",
  LblEditBooking: "Modifier la réservation",
  LblLicenseCheck: "Vérification de licence",
  LblBookingLicenseCheck: "Vérification de la licence de réservation",
  LblBookings: "Réservations",
  LblSharedVehicleGroups: "Groupes de pool",
  LblSharedVehicleGroupOverview: "Aperçu du groupe de pool",
  LblDriver: "Conducteur",
  LblLicenceNumber: "Numéro de permis de conduire",
  LblDriverName: "Nom du conducteur",
  LblDriverSVG: "Conducteur groupe de pool",
  LblDriverUserName: "Nom d'utilisateur du conducteur",
  LblSelectFuelType: "Sélectionnez le type de carburant",
  LblSelectPricingCatagory: "Sélectionnez la gamme de prix",
  LblSelectBodyStyle: "Sélectionnez le type de carrosserie",
  LblSelectVehicleClass: "Sélectionnez la catégorie de véhicule",
  LblVehicleAttributeCategory: "Catégorie de caractéristiques du véhicule",
  LblVehicleAttributeName: "Caractéristique",
  LblVehicleAttributeDesc: "Description",
  LblVehicleAttribute: "Caractéristique du véhicule",
  LbAdditionallVehicleAttribute: "Caractéristiques supplémentaires",
  LblVehicleAttributeCategories: "Catégories pour les attributs du véhicule",
  LblRegular: "Standard",
  LblWeekEnd: "Week-end",
  LblDayCT: "Jour",
  LblExtraTimeBefore: "Temps supplémentaire plus tôt (en minutes)",
  LblExtraTimeAfter: "Temps supplémentaire après (en minutes)",
  LblFreeTextDescription: "Indiquez le tarif, les heures de début et de fin de la réservation particulière (champs libre)",
  LblPeriodRate: "Période tarifaire",
  LblPeriodRateVat: "TVA période tarifaire",
  LblSelectContractTypeType: "Sélectionnez le type de type de contrat",
  LblContractTypeType: "Type de type de contrat",
  LblContractType: "Type de contrat",
  LblContractName: "Nom du contrat",
  LblContractTypeGroup: "Groupe de type de contrat",
  LblContractTypeGroupName: "Nom du groupe du type de contrat",
  LblContractAvailableDays: "Jours disponibles contrat",
  LblApplicableDays: "Jours applicables",
  LblDayStartTime: "Heure de début du jour (hh:mm)",
  LblDayEndTime: "Heure de fin du jour (hh:mm)",
  LblApplicableStartTime: "Heure de début applicable (hh:mm)",
  LblApplicableEndTime: "Heure de fin applicable (hh:mm)",
  LblComment: "Remarque",
  LblProcessingFee: "Frais administratifs",
  LblTripDisplayType: "De quelle façon les trajets doivent-ils être affichées dans les rapports ?",
  LblAllTripsIndividually: "Tous les trajets séparément",
  LblAllTripsGrouped: "Tous les trajets regroupés en un seul trajet",
  LblVatPercentage: "Pourcentage TVA",
  LblVatIncludedInPrice: "TTC",
  LblPlateformUsageCost: "Frais d'utilisation de la plateforme",
  LblCatA: "Catégorie A",
  LblCatB: "Catégorie B",
  LblCatC: "Catégorie C",
  LblCatD: "Catégorie D",
  LblCatE: "Catégorie E",
  LblCatF: "Catégorie F",
  LblCatG: "Catégorie G",
  LblCatH: "Catégorie H",
  LblHourlyRate: "Coûts de la location",
  LblMileageRate: "Prix au kilomètre",
  LblFixedFee: "Frais fixes",
  LblPricingModel: "Modèle de tarification",
  LblContractStartDateTime: "Date de début du contrat",
  LblContractEndDateTime: "Date / heure de fin du contrat",
  LblContractTypeHistory: "Historique",
  LblContractTypPeriod: "Période du type de contrat",
  LblInactiveContractTypeGroupReason: "Motif de la désactivation du groupe de types de contrat",
  LblPenaltyAmount: "Montant de la pénalité",
  LblPenaltyTimeInterval: "Intervalle de temps des pénalités (en minutes)",
  LblIsPenaltyEnabled: "Pénalité activée",
  LblJanuary: "Janvier",
  LblFebruary: "Février",
  LblMarch: "Mars",
  LblApril: "Avril",
  LblMay: "Mai",
  LblJune: "Juin",
  LblJuly: "Juillet",
  LblAugust: "Août",
  LblSeptember: "Septembre",
  LblOctober: "Octobre",
  LblNovember: "Novembre",
  LblDecember: "Décember",
  LblSJan: "Jan.",
  LblSFeb: "Fév.",
  LblSMar: "Mar.",
  LblSApr: "Avr.",
  LblSMay: "Mai",
  LblSJun: "Juin",
  LblSJul: "Juil.",
  LblSAug: "Août",
  LblSSep: "Sep.",
  LblSOct: "Oct.",
  LblSNov: "Nov.",
  LblSDec: "Déc.",
  LblSunday: "Dimanche",
  LblMonday: "Lundi",
  LblTuesday: "Mardi",
  LblWednesday: "Mercredi",
  LblThursday: "Jeudi",
  LblFriday: "Vendredi",
  LblSaturday: "Samedi",
  LblSSu: "Di",
  LblSMo: "Lu",
  LblSTu: "Ma",
  LblSWe: "Me",
  LblSTh: "Je",
  LblSFr: "Ve",
  LblSSa: "Sa",
  LblForgotPassword: "Mot de passe oublié",
  LblChangePassword: "Modifier mot de passe",
  LblOldPassword: "Ancien mot de passe",
  LblNewPassword: "Mot de passe",
  LblProfileUpdatedSucessFully: "Profil modifié avec succès",
  LblPasswordChangedSucessFully: "Votre mot de passe a été modifié",
  LblUpdateProfile: "Modifier profil",
  LbLReasonVehicle: "Motif de l'indisponibilité",
  LblReasonDriver: "Motif de suspension du conducteur",
  LblFrom: "De",
  LblTo: "À",
  LblBooking: "Réservation ",
  LblBookingRequest: "Demande de réservation",
  LblOverview: "Aperçu des réservations",
  LblOverviewList: "Liste des réservations",
  LblApproveBooking: "Approbation de la réservation",
  LblApprove: "Approuver",
  LblReject: "Rejeter",
  LblNormal: "Nouvelle réservation",
  LblSpecial: "Réservation particulière",
  LblHistory: "Historique de la réservation",
  LblBookingStatus: "Statut de la réservation",
  LblBookingType: "Type de réservation",
  LblAdminRemarks: "Remarque Admin",
  LblBookingRemarks: "Remarques de la réservation",
  LblDriverRemarks: "Remarques du conducteur",
  LblBookingReferenceId: "Nº de réservation",
  LblAbort: "Annuler",
  LblRevoke: "Supprimer",
  LblStatus: "Statut",
  LblReference: "Nº de référence",
  LblRemarks: "Remarques",
  LblSearchForVehicle: "Trouver véhicule",
  LblVehicleOverview: "Aperçu des véhicules",
  LblConfirmBooking: "Confirmer la réservation",
  LblCurrentBookingDetail: "Détails de la réservation actuelle",
  LblCheckAvailability: "Contrôler la disponibilité",
  LblBookingStartDateTime: "Commencer la réservation",
  LblBookingEndDateTime: "Terminer la réservation",
  LblSource: "Lieu de prise en charge",
  LblRecurring: "Récurrente",
  LblRecurringId: "Nº de réservation récurrente",
  LblRecurringBookingReference: "Référence du nº de réservation récurrente",
  LblDaily: "Chaque jour",
  LblWeekly: "Chaque semaine",
  LblMonthly: "Chaque mois",
  LblRecurrenceEndDate: "Date de fin de la récurrence",
  LblSearch: "Chercher",
  LblBookNow: "Réserver",
  LblUpdateBooking: "Modifier la réservation",
  LblEditCarNotAvailable: "Le véhicule réservé à l'origine n'est pas disponible",
  LblSortBy: "Trier par",
  LblAvaibility: "Disponibilité",
  LblNoMatchingVehicle: "Aucun véhicule disponible trouvé",
  LblAvailableSlots: "Périodes disponibles",
  LblFeatures: "Caractéristiques",
  LblDriverDetail: "Données du conducteur",
  LblBookingDetail: "Données de la réservation",
  LblVehicleDetail: "Données du véhicule",
  LblBookingSuccess: "Votre demande de réservation a bien été créée. Vous recevrez une copie de cette demande à l'adresse mail enregistrée. Vous recevrez également une notification pour approbation et vous serez averti lorsque la réservation sera acceptée.",
  LblBookingUpdateSuccess: "La réservation a bien été mise à jour. Une notification a été envoyée à l'adresse mail du conducteur.",
  LblBlockNormalBooking: "Votre compte est bloqué. Veuillez contacter l'administrateur.",
  LblSingle: "Unique",
  LblSeries: "Série",
  LblLicenceRequired1: "Merci de bien vouloir valider le numéro du permis de conduire, allez à",
  LblLicenceRequired2: "Pour mettre à jour les détails du permis de conduire.",
  LblAcceptOrReject: "Approuver / rejeter",
  LblSpecialBooking: "Réservation particulière",
  LblAffectedBooking: "Réservation concernée",
  LblSpecialBookingType: "Type de réservation particulière",
  LblSelectSpecialBookingType: "Sélectionnez le type de réservation particulière",
  LblSpecialBookingConfiramtionmsg: "Êtes-vous certain de vouloir créer une réservation particulière ?",
  LblEndDate: "Fin de la réservation récurrente",
  LblNotification: "Notification",
  LblSubject: "Sujet",
  LblDate: "Date",
  LblWelcomeNotification: "Bienvenue dans la boîte de réception des notifications",
  LblTemplate: "Modèle",
  LblTemplateList: "Liste des modèles",
  LblTemplateName: "Nom du modèle",
  LblTemplateType: "Type de modèle",
  LblIsEmailTemplate: "Adresse mail",
  LblIsWebTemplate: "Web",
  LblBody: "Carrosserie",
  LblNotificationEventManagement: "Gestion de notification d'événement",
  LblNotificationEvent: "Notification d'événement",
  LblModuleName: "Nom du module",
  LblSMS: "SMS",
  LblUserType: "Type d'utilisateur",
  LblTimeBlock: "Bloc horaire",
  LblTimeBlockName: "Nom du bloc horaire",
  LblTimeBlockWeekDays: "Jours de la semaine du bloc horaire",
  LblTimeBlockStartTime: "Heure de début du bloc horaire",
  LblTimeBlockEndTime: "Heure de fin du bloc horaire",
  LblTimeBlockStartDate: "Date de début du bloc horaire",
  LblTimeBlockEndDate: "Date de fin du bloc horaire",
  LblServiceOffer: "Offre de services",
  LblServiceOfferList: "Liste d'offre de services",
  LblServiceOfferName: "Nom du service",
  LblServiceOfferType: "Type de service",
  LblStandardTariff: "Tarif standard",
  LblTimeUsedOrBooked: "Temps utilisé / réservé",
  LblDistance: "Distance",
  LblPenalty: "Pénalité",
  LblAdditional: "Extra",
  LblAdditionalAbbr: "En supplément",
  LblUnit: "Unité",
  LblWegoAdmin: "Administrateur WeGo",
  LblWegoAdmins: "Admins WeGo",
  LblReSend: "Envoyer à nouveau",
  LblResendActivationMail: "Mail d'activation",
  LblResendActivationMailFailure: "Impossible d'envoyer le mail d'activation",
  LblResendActivationMailSuccess: "Mail d'activation envoyé",
  LblSubscription: "Abonnement",
  LblSubscriptionName: "Nom de l'abonnement",
  LblTimeInterval: "Intervalle de temps",
  LblAmount: "Quantité",
  LblFreeKilometer: "Crédits offerts",
  LblFreeMinute: "Minutes offertes",
  LblFreeHours: "Heures offertes",
  LblNumberOfSubscription: "Nombre d'abonnements",
  LblUnsubscribe: "Résilier l'abonnement",
  LblsubscribeEndDate: "Date de fin de l'abonnement",
  LblSubscriptionStartDate: "Date de début de l'abonnement",
  LblSpecialPeriod: "Période particulière",
  LblspecialPeriodName: "Nom de la période particulière",
  LblSpecialPeriodStartTime: "Heure de début de la période particulière",
  LblSpecialPeriodEndTime: "Heure de fin de la période particulière",
  LblSpecialPeriodWeekDays: "Jours de la semaine de la période particulière",
  LblNormalPeriod: "Période normale",
  LblSpecialPeriods: "Période particulière",
  LblWegoAdminDependencyValidation: "L'administrateur WeGo ne peut pas être supprimé car il est rattaché à une autre entité",
  LblBookingInvoice: "Facture de réservation",
  LblInvoiceStatus: "Statut de la facture",
  LblAdminDependencyValidation: "Le rôle d'administrateur ne peut pas être supprimé car il est rattaché à une autre entité",
  LblAdminDependencyAlert: "Notification de rattachement à l'administrateur",
  LblTotalHours: "Temps total",
  LblInvoiceType: "Type de facture",
  LblSummary: "Résumé",
  LblTotalKm: "Distance totale (en km.)",
  LblTotalExpense: "Totalité des coûts",
  LblInvoiceNumber: "Numéro de factuur",
  LblAdminDependencyValidationOnDelete: "L'administrateur sélectionné ne peut pas être supprimé car il est rattaché à une autre entité",
  LblBegin: "Début",
  LblEnd: "Fin",
  LblVat: "TVA",
  LblTotal: "Total",
  LblInvoiceRequestDateTime: "Date / heure de demande de facture",
  LblInvoiceSendDateTime: "Date / heure d'envoi de la facture",
  LblInvoiceDateTime: "Date / heure de la facture",
  LblInvoiceDetail: "Détails de la facture",
  LblResend: "Renvoyer",
  LblDownload: "Télécharger",
  LblResendInvoiceConfirm: "Êtes-vous certain de vouloir renvoyer %0 ?",
  LblRemoveContactPersonConfirm: "Êtes-vous sûr de vouloir supprimer le contact ?",
  LblPenaltyRate: "Penalité",
  LblSendInvoiceConfirm: "Êtes-vous sûr de vouloir envoyer la facture ?",
  LblInvoicing: "Facturation",
  LblInvoices: "Facture",
  LblCarwiseConfiguration: "Configuration Carwise",
  LblCarwiseConnectionUrl: "URL de connexion",
  LblCarwiseConnectionUsername: "Nom de la connexion",
  LblCarwiseEnable: "Carwise activé",
  LblCarwiseConnectionPassword: "Mot de la passe de la connexion",
  LblCarwiseAutoDeleteFrequencyInDays: "Fréquence de suppression automatique (en jours)",
  LblDamageImageExtentions: "Format du fichier des dommages",
  LblDone: "Prêt",
  LblClear: "Effacer",
  LblEditPage: "Modifier %0",
  LblAddPage: "Ajouter %0",
  LblListPage: "Aperçu %0",
  LblAll: "Tout",
  LblProfile: "Profil",
  LblSignOut: "Se déconnecter",
  LblTemplateNote1: "Veuillez ne pas supprimer ou modifier le texte rédigé comme {nom de la variable}. Il s'agit d'un élément variable qui sera remplacé par la valeur correspondante de la base de données lors de l'envoi.",
  LblTemplateNote2: "Veuillez ne pas modifier la structure du tableau. Vous pouvez en ajouter un nouveau, mais pas modifier celui qui existe déjà.",
  LblTemplateNote3: "Veuillez vous assurer, lorsque vous copiez un « placeholder » et que vous le collez dans un éditeur HTML, que vous le « collez comme texte brut ».",
  LblConfirmUnsubscribe: "Êtes-vous sûr de vouloir vous déconnecter ?",
  LblDriveHours: "Heures disponibles",
  LblVehicleImage: "Image du véhicule",
  LblMaintenance: "Entretien",
  LblUNAVAILABLE: "Indisponible",
  LblTestInvoiceGenerator: "Générateur de factures test",
  LblInvoicingDateTime: "Date / heure de la facture (UTC)",
  LblGenerateInvoice: "Générer la facture",
  LblDeleteAllSelectedRecords: "Supprimer toutes les lignes sélectionnées",
  LblCancelAllSelectedRecords: "Annuler toutes les lignes sélectionnées",
  "LblExportAll(CSV)": "Exporter (CSV)",
  LblContractTypeGroupAvailableForSubscription: "Aucun groupe de type de contrat n'est disponible pour ajouter %0.",
  LblAddContactPerson: "Ajouter une personne à contacter",
  LblRemoveContactPerson: "Supprimer une personne à contacter",
  LblNote: "Note",
  LblCompletelyEndConfirm: "Terminer complètement le trajet",
  LblEndTrip: "Terminer le trajet",
  LblTestTrip: "Trajet test",
  LblTripSimulator: "Simulateur de trajet",
  LblTestTripSuccess: "Trajet test créé avec succès",
  LblDrivingStartDateTime: "Date / heure de début du trajet",
  LblDrivingEndDateTime: "Date / heure de fin du trajet",
  LblInvoiceMoment: "Moment de la facturation",
  LblExtend: "Prolonger",
  LblExtendRequire: "Veuillez saisir le temps de prolongation (en minutes)",
  LblExtendInfoMsg: "Vous pouvez prolonger votre réservation jusqu'à %0 minutes.",
  LblExtendValidationMsg: "Cette réservation ne peut pas être prolongée",
  LblExtendBooking: "Prolonger la réservation",
  LblBookingExtendedSuccess: "Réservation prolongée",
  LblOverExtendValidationMsg: "La réservation peut être prolongée de %0 minutes tout au plus",
  LblUnLock: "Déverrouiller",
  LblLock: "Verrouiller",
  LblVehicleStatus: "Statut du véhicule",
  LblTripSuccess: "Trajet enregistré",
  LblLockSuccessfully: "Véhicule verrouillé avec succès",
  LblLockCompletelySuccessfully: "Véhicule verrouillé",
  LblUnLockSuccessfully: "Véhicule déverrouillé",
  LblUnlockProblem: "Problème lors de la commande de déverrouillage",
  LbllockProblem: "Problème lors de la commande de verrouillage",
  LblLockCarCompletely: "Fermer et terminer la réservation",
  LblStartDateTime: "Date / heure de début",
  LblEndDateTime: "Date / heure de fin",
  LblBookingTripDetail: "Détails du trajet de la réservation",
  LblAddNewTrip: "Ajouter un nouveau trajet",
  LblBookingExpenseDetail: "Détails des frais de réservation",
  LblUnlockErrorMessage: "Aucun groupe de type de contrat actif n'est disponible au moment de la réservation.",
  LblExpenseAmount: "Montant des frais",
  LblExpenseName: "Nom des dépenses",
  LblExpenseSuccess: "Dépenses sauvegardées avec succès",
  LblReceipt: "Réception",
  LblHelpdeskNo: "Numéro du service d'assistance",
  LblInactiveReason: "Motif de l'inactivité",
  LblBookingExpired: "Vous ne pouvez pas déverrouiller le véhicule si la réservation a expiré.",
  LblTripCalculationInProgress: "J'espère que vous avez fait un bon voyage ! Le véhicule se fermera dans quelques secondes.",
  LblActualInvoiceGenerationDate: "Date de création de la facture",
  LblAvailableForAllSlots: "Véhicule disponible pour tous les créneaux horaires",
  LblUnAvailableSlots: "Créneaux horaires non disponibles",
  LblNoOfDrivers: "Nombre de conducteurs",
  LblVTSReqLogDetail: "Demande de détails sur le journal VTS",
  LblVTSReqDateTime: "Date / heure de la demande",
  LblVTSProcessTime: "Délai de traitement",
  LblVTSResTime: "Heure du résultat",
  LblVTSReqType: "Type de demande",
  LblVTSResult: "Résultat",
  LblSVGDriversList: "Conducteurs de groupe de pool",
  LblVehicleInformation: "Informations sur le véhicule",
  LblVTSVehicle: "VTS Voertuig",
  LblFleetId: "ID de la flotte",
  LblContractId: "ID du contrat",
  LblVIN: "VIN",
  LblVTSVehicleUpdateSuccess: "Véhicule %0 avec succès",
  LblTroubleShootVTS: "Dépannage du VTS",
  LblVTSVehicleList: "Liste des véhicules VTS",
  
  //Booking Type
  LblNORMALBOOKINGTYPE: "STANDARD",
  LblMAINTENANCEBOOKINGTYPE: "ENTRETIEN",
  LblUNAVAILABLEBOOKINGTYPE: "NON DISPONIBLE",
  
  //Booking Request Status
  LblAPPROVEDBOOKINGREQUEST: "APPROUVÉE",
  LblREJECTEDBOOKINGREQUEST: "REJETÉE",
  LblPENDINGBOOKINGREQUEST: "EN ATTENTE",
  
  //Booking Status
  LblABORTED: "INTERROMPUE",
  LblCANCELLED: "ANNULÉE",
  LblCONFIRMED: "CONFIRMÉE",
  LblFINISHED: "FINALISÉE",
  LblNOSHOW: "NON PRÉSENTATION",
  LblPENDING: "EN ATTENTE",
  LblREVOKED: "ANNULÉE",
  LblRUNNING: "LANCÉE",
  LblREADYFORPAYMENT: "PRÊTE POUR PAIEMENT",
  
  //Invoice Status
  LblOPEN: "OUVERTE",
  LblSENT: "ENVOYÉE",
  LblCLOSED: "CLÔTURÉE",
  LblREQUESTFORPAYMENT: "DEMANDE DE PAIEMENT",
  LblREOPEN: "RÉOUVERTE",
  LblFileNotFound: "Le fichier n'existe pas, veuillez contacter le service d'assistance.",
  
  // Error Log
  LblErrorLog: "Rapport d'erreurs",
  LblComponentName: "Nom du composant",
  LblLogType: "Type de journal",
  LblEventDateTime: "Date / heure de l'événement",
  
  // Interface Status
  LblInterfaceStatus: "Statut de l'interface",
  LblLastStatusChangeDateTime: "Date / heure du dernier changement de statut",
  LblLastCarwisePollDateTime: "Date / heure dernier sondage Carwise",
  LblUpdatedDateTime: "Date et heure modifiées",
  LblMonitoring: "Suivi",
  LblDropoffMessage: "Message de dépôt",
  LblPreferredlanguage: "Langue préférée",
  LblDebtornr: "numéro du débiteur",
  
  //ErrorEscalation
  LblDuplicateErrorEscalation: "Doublons trouvés dans la configuration d'escalade d'erreurs",
  LblErrorEscalation: "Escalade d'erreurs",
  LblComponent: "Composant",
  LblSelectAdminLevel: "Sélectionnez le niveau de l'administrateur",
  LblWegoAdminLevel: "Niveau de l'administrateur de Wego",
  LblCustomerAdminLevel: "Niveau de gestion des clients",
  LblInstanceAdminLevel: "Niveau de gestion des instances",
  LblEnableLogin: "Ouverture de session",
  LblEnableErrorEscalation: "Activation de l'escalade d'erreurs",
  LblErrorEscalationMinutes: "Erreur dans l'escalade en minutes",
  
  //Report Damage
  LblReportDamage: "Signaler des dommages",
  LblCompleteDamageReport: "Soumettre un rapport de dommages",
  LblDamageFile: "Fichier de dommages",
  LblDescribe: "Décrivez le(s) dommage(s) ...",
  LblCause: "Décrivez la cause ...",
  LblReportDamageMsg: "Dommages signalés",
  LblSelectFile: "Sélectionnez le fichier",
  
  // Import Data
  LblCSVImport: "Importer un fichier CSV",
  LblValidateCSV: "Valider CSV",
  LblImportValidPerson: "Importer une personne valide",
  LblImportValidDriver: "Importer un conducteur valide",
  LblImportValidVehicle: "Importer un véhicule valide",
  LblCSVType: "Type de fichier CSV",
  LblCSVFile: "Fichier CSV",
  LblRecordImportedSuccess: "%0 a été importé",
  LblInvalidReason: "Raison invalide",
  LblSameVTSCommand: "La demande est déjà en cours de traitement. Veuillez patienter s'il vous plaît.",
  LblImportPerson: "Importer une personne",
  
  //Subscription related Changes
  LblSubscriptionInterval: "Période d'abonnement",
  LblPaymentInterval: "Intervalle de paiement",
  LblInvoicInterval: "Intervalle de facturation",
  LblInterval: "Intervalle",
  LblInvoiceMomentDay: "Moment de facturation (jour de la semaine)",
  LblInvoiceMomentMonth: "Moment de facturation (jour du mois)",
  LblFreeMinuteInterval: "Intervalle de minutes gratuites",
  LblFreeKMInterval: "Intervalle de crédits gratuits",
  LblSelectSubscriptionInterval: "Sélectionnez la période d'abonnement",
  LblSelectInvoiceInterval: "Sélectionnez l'intervalle de facturation",
  LblSelectPaymentInterval: "Sélectionnez l'intervalle de paiement",
  LblSelectFreeKMInterval: "Sélectionnez l'intervalle de kilomètres gratuits",
  LblSelectFreeMinInterval: "Sélectionnez un intervalle de minutes gratuites",
  LblYearlySub: "Annuel",
  LblMonthlySub: "Mensuel",
  LblWeeklySub: "Hebdomadaire",
  LblFreePerWeek: "Par semaine",
  LblFreePerMonth: "Par mois",
  LblFreePerTriMonth: "Per 3 mois",
  LblFreePerBiannual: "Par 6 mois",
  LblFreePerYear: "Par an",
  LblDefaultContractTypeGroup: "Groupe de types de contrats standards",
  LblSelectDefaultContractTypeGroup: "Sélectionnez le type de contrat standard du groupe",
  LblSendInvoiceToDriver: "Envoyer la facture au chauffeur",
  LblInherit: "Reprendre",
  
  //Invoice Moment
  LblDayOfMonth: "Jour du mois",
  LblDayOfWeek: "Jour de la semaine",
  LblSelectDayOfWeek: "Sélectionnez un jour de la semaine",
  LblInstanceLogo: "Logo de l'instance",
  LblResetPasswordFailure: "Le mot de passe ne peut pas être réinitialisé, car l'utilisateur n'a pas encore été activé.",
  LblInvoiceDeleteValidation: "Impossible de supprimer une facture en raison de son association avec une autre entité",
  
  //Additional Free Item
  LblAdditionalFreeItems: "Crédits gratuits supplémentaires",
  LblDateAwared: "Date d'attribution",
  LblAdditionalFreeItemsMenu: "Crédits gratuits supplémentaires",
  LblTotalFreeKilometer: "Total des kilomètres gratuits",
  LblTotalFreeMinute: "Total des minutes gratuites",
  LblCurRemainFreeKilometer: "Kilomètres gratuits restants",
  LblPrevRemainFreeKilometer: "Quantité précédente de kilomètres gratuits restants",
  LblCurRemainFreeMinute: "Minutes gratuites restantes",
  LblPrevRemainFreeMinute: "Quantité précédente de minutes gratuites restantes",
  LblPrevious: "Précédent",
  LblCurrent: "Actuel",
  
  //Instance Clone
  LblInstanceClone: "Cloner l'instance",
  LblNewInstanceName: "Nom de la nouvelle instance",
  LblCloneResult: "Cloner le résultat",
  LblCloneStatus: "Statut du clone",
  CloneError: "Une erreur s'est produite lors du clonage de l'instance et de ses entités.",
  
  //SubscriptionAvailabilityRestriction
  LblSubscriptionAvailabilityRestriction: "Limitation de la disponibilité des abonnements",
  LblStartDay: "Jour de début",
  LblEndDay: "Jour de fin",
  LblStartTime: "Heure de début (hh:mm)",
  LblEndTime: "Heure de fin (hh:mm)",
  LblRestriction: "Restriction",
  
  //Trip Detail Report
  LblTripDetailReport: "Aperçu du trajet",
  LblTripDetailList: "Aperçu détaillé de la réservation",
  LblSearchTripforDriver: "Trouver les trajets pour le conducteur",
  LblExportReport: "Exporter le rapport",
  LblValidateLiceanceNumberMessage: "Veuillez vérifier votre permis de conduire",
  LblBookingIntervalRate: "Tarif de l'intervalle",
  LblPerHour: "Par heure",
  LblPerBookingIntarval: "Par intervalle de réservation",
  LblTimeRate: "Tarif horaire",
  LblToalBookingDuration: "Durée de la réservation",
  LblTripComments: "Remarque sur le voyage",
  LblTripCommentDescription: "Entrer la remarque de voyage",
  LblTripCommentError: "Veuillez entrer une remarque sur le voyage",
  LblShowTripComment: "Voir la remarque",
  LblAddTripComment: "Ajouter une remarque",
  LblTripCommentBy:"Remarque de",
  LblTripCommentOn: "Remarque sur",
  LblCleanRequire: "Nettoyage nécessaire",
  LblFualRequire: "Carburant nécessaire",
  LblVehicleDamageList: "Liste des dommages au véhicule",
  LblDamageCause: "Cause des dommages",
  LblDamageReportedBy: "Signalé par",
  LblDamageReportedOn: "Signalé le",
  LblConfirmResolveDamage: "Êtes-vous sûr de vouloir supprimer le rapport de dommages ?",
  LblVehicleDamgeResolveSuccess: "Rapport de dommages supprimé",
  LblDamageDesc: "Description des dommages",
  LblFutureBooking: "Réservations futures",
  LblVehFutureBookingList: "Liste des futures réservations de véhicules",
  LblResolveDamge: "Supprimer le rapport de dommages",
  LblReserved: "Réservé",
  LblVehicleInfoSuccess: "Informations sur le véhicule enregistrées",
  LblInformation: "Informations",
  LblVtsServiceStatus: "État du service VTS",
  LblVtsLicencetag: "Plaque d'immatriculation VTS",
  LblVtsDoorStatus: "Statut de la portière",
  LblVtsIssueCommand: "Envoyer une commande",
  LblVehicleLocation: "Emplacement du véhicule",
  LblEventHistory: "Historique des événements VTS",
  LblVehicleObuStatus: "Statut de l'OBU du véhicule",
  LblVTSHistory: "Historique des événements VTS",
  LblRequestType: "Type de commande",
  LblCommandInitiator: "Commande envoyée par",
  LblResult: "Résultat",
  LblVTSRequestTime: "Temps de demande de VTS",
  LblVTSResultTime: "VTS Temps de résultat",
  LblWegoProcessTime: "Délai de traitement WeGo",
  LblWegoRequestTime: "Durée de la demande WeGo",
  LblWegoResultTime: "Temps de résultat WeGo",
  LblView: "Aperçu",
  LblVehicleNotInitialized: "Véhicule non initialisé",
  LblLastReceivedTime: "Heure du dernier message reçu",
  LblFreePerBookingInterval: "Par intervalle de réservation",
  LblVtsLocation: "VTS locatie",
  LblSelectObuType: "Sélectionnez le type d'OBU",
  LblObuType: "Type d'OBU",
  LblDeviceId: "Id. du dispositif",
  LblClaimCode: "Code de réclamation",
  LblRetriveAddress: "Obtenir l'adresse",
  LblCrearedDate: "Date de création",
  LblCreatedBy: "Créée par",
  LblPerBooking: "Par réservation",
  LblSelectFilter: "Sélectionner le filtre",
  LblAuditEntries: "Contrôler les données saisies",
  LblFilter: "Filtre",
  LblCategory: "Catégorie",
  LblEventName: "Nom de l'événement",
  LblEventData: "Données de l'événement",
  LblMoment: "Moment",
  LblUser: "Utilisateur",
  LblNoEventDataFound: "Aucune donnée de l'événement trouvée",
  LblEventViewer: "Consulter l'événement",
  LblOBU: "OBU",
  LblClone: "Copier",
  LblCloneVehicle: "Copier %0",
  LblFualNotRequire: "Carburant non requis",
  LblCleanNotRequire: "Nettoyage non requis",
  LblSubscriptionInfo: "Informations concernant l'abonnement",
  LblVehiclDamaged: "Véhicule endommagé",
  LblVehicleNotDamaged: "Véhicule non endommagé",
  LblDamage: "Dommages",
  LblFreeBooking: "Modifier les frais de réservation",
  LblBookingCustomFee: "Total des frais de réservation",
  LblFreeBookingSuccess: "Frais de réservation enregistrés",
  LblEnterLocation: "Saisir un emplacement",
  LblHomeLocation: "Site d'origine",
  LblLocationMode: "Paramètres du site",
  LblMeter: "Mètre",
  LblLocation: "Site",
  LblPickupLocation: "Site de prise en charge",
  LblLocationUnavailable: "Site non disponible",
  LblAvailabilityCalander: "Calendrier des disponibilités",
  LblAvailableOn: "Disponible le",
  LblGeofenceEnabled: "Géofence active",
  LblLocationNotFound: "Impossible de déterminer l'adresse",
  LblAddressNotAvailable: "Impossible de déterminer l'adresse sur ce site",
  LblReports: "Rapports",
  LblDrivers: "Conducteurs",
  LblTemplates: "Modèles",
  LblPlaceHolder: "Placeholder",
  LblSampleTemplate: "Exemple de modèle",
  LblLatexFileDownloadValidation: "Contenu Latex non valide",
  LblLocationDataExchangeNotAssign: "Ce véhicule ne peut être réservé s'il n'y a pas de véhicule VTS attribué. Souhaitez-vous continuer ?",
  LblRevenue: "Chiffre d'affaires",
  
  // Vehicle Occupancy Report
  LblVehicleOccupancyReport: "Rapport d'occupation",
  LblReservedTime: "Temps réservé",
  LblUsageTime: "Durée d'utilisation",
  LblUsageTimeAtOffice: "Utilisation pendant les heures de bureau",
  LblUsageTimeoutOffice: "Utilisation en dehors des heures de bureau",
  LblRevenuePerVehicleReport: "Chiffre d'affaires par véhicule",
  LblSearchRevenuePerVehicle: "Rechercher chiffre d'affaires par véhicule",
  LblRevenuePerVehicleList: "Liste des chiffres d'affaires par véhicule",
  lblThreshold: "Avertir au préalable à partir de",
  
  //OdometerLogTrail
  LblOdometerLogTrail: "Historique du compteur kilométrique",
  LblUserProvidedOdometerValueInKmr: "Kilométrage (en km)",
  LblDescriptionOfDeviation: "Explication des écarts",
  LblFromOdometer: "Compteur kilométrique de",
  LblToOdometer: "Compteur kilométrique à",
  LblAddDescriptionOfDeviation: "Ajouter une explication pour l'écart",
  LblDeviation: "Écart (en km)",
  LblLastOdometerValue: "Kilométrage précédent (en km)",
  LblLastOdometerDT: "Date du compteur kilométrique précédent",
  LblodometerConfiguration: "Paramètres du compteur kilométrique",
  LblEnableOnApp: "Afficher dans l'appli",
  LblWarningPer: "Avertissement (%)",
  LblOdometerRegistered: "Kilométrage enregistré",
  LbLOdometerEnabled: "Compteur kilométrique en marche",
  LblOdometerValue: "Kilométrage",
  LblMaintenancePlanningList: "Planification de l'entretien",
  LblSearchMaintenancePlanningValue: "Recherche dans la planification de l'entretien",
  LblMaintenancePlanningreport: "Rapport de planification de l'entretien",
  LblShowDeviation: "Afficher l'écart sans explication",
  LblTitle: "Titre",
  LblFooterText: "Note de pas de page",
  LblvalidEmailDomain: "Seules les adresses mail de ce domaine sont autorisées",
  LblURLSettings: "Paramètres URL",
  LblSuccessUrl: "Paramètres URL réussis",
  LblEmailSettings: "Paramètres des courriels",
  LblSendActivationEmail: "Envoyer des courriels d'activation automatique",
  LblSendConfirmationEmail: "Envoyer des courriels de confirmation automatiques",
  LblRequireAdminApprovel: "Autorisation obligatoire de l'administrateur pour une nouvelle inscription",
  LblDriverInformationToBeInclude: "Informations sur le conducteur à ajouter",
  LblSignUpForm: "Formulaire d'inscription",
  LblSignupForms: "Formulaires d'inscription",
  LblSignupFormsOverview: "Aperçu des formulaires d'inscription",
  LblWhoCanApprove: "Qui peut autoriser les nouvelles inscriptions ?",
  LblSignupFormLogo: "Logo formulaire d'inscription",
  LblChooseSubscription: "Choisissez les abonnements figurant sur le formulaire d'inscription",
  LblSignupParameter: "Page web formulaire d'inscription",
  LblSignupParameterText: "Texte URL formulaire d'inscription",
  DomainNameString: "Noms de domaine séparés par des virgules (tels que gmail.com,yahoo.com)",
  SignupParameterString: "Seuls les lettres, les chiffres et les - sont autorisés",
  LblAvailability: "Disponibilité",
  LblSettings: "Paramètres",
  LblCurrentStatus: "Statut actuel",
  LblFlags: "Flags",
  LblNA: "Non disponible",
  
  //Sign up form
  LblConfirmEmail: "Confirmer l'adresse mail",
  LblSignup: "S'inscrire",
  LblSignupsOverView: "Aperçu des inscriptions",
  LblSignupApproval: "Autorisation inscriptions",
  LblAccept: "Accepter",
  LblSignupFormDescription: "Descriptif du formulaire d'inscription",
  LblCurrentOdometerValue: "Kilométrage actuel",
  LblCurrentOdometerDateTime: "Heure du kilométrage actuel",
  LblCreateDirectDebitFile: "Créer un fichier de prélèvement automatique",
  LblCheckEmptyIbanNumber: "Vérifier les numéros IBAN",
  LblCreatedDate: "Date de création",
  LblIncludeInDirectDebit: "Ajouter au fichier de prélèvement automatique",
  LblDirectDebitFileDate: "Date fichier de prélèvement automatique",
  LblDirectDebitConfiguration: "Configuration du prélèvement",
  LbLDirectDebitEnabled: "Activer la fonctionnalité de prélèvement automatique",
  LblDirectDebitEnableper: "Fonctionnalité de collecte activée à partir de",
  LbLCreditorDetails: "Informations sur le créancier",
  LblAddress: "Adresse",
  LblIBANNumber: "IBAN",
  LblCountryCode: "Code pays",
  LbLBillingInformation: "Données de paiement",
  LblInvoicingDetails: "Données de facturation",
  LbLSubjectToDirectDebit: "Utiliser prélèvement automatique ?",
  
  //Batch Upload Person
  LblBatchUploadPersonSetting: "Paramétrages importation de personnes",
  LblShowBatchUploadInfo: "Activer la fonctionnalité de saisie par lots pour des personnes ?",
  LblAllowBatchUpload: "Rôle autorisé à importer",
  LblAllowActivationMail: "Utiliser courriels d'activation",
  LblGenerateRandomPassword: "Le système génère des mots de passe",
  LblUserUploadPassword: "Mot de passe dans le fichier d'importation",
  LblFieldToUploadedOrValidated: "Champs fournis",
  LblBatchUploadPerson: "Importer des personnes",
  LblBatchUpload: "Importer des personnes",
  LblDownloadTemplate: "Exemple de fichier d'importation",
  LblUserAssignSVGMessage: "L'utilisateur n'est pas encore assigné au groupe de pool !",
  LblInvalidRecordReason: "Dossier(s) non valide(s)",
  LblSelectedSVGs: "Groupe(s) de pool sélectionné(s)",
  LblDashboardConfiguration: "Configuration du tableau de bord",
  LblEnableCurrentLocation: "Activez l'option « Emplacement actuel »",
  LblDefaultLocation: "Emplacement affiché par défaut",
  LblEnableAutoUpdate: "Activer l'actualisation automatique",
  LblPriorityNotificationSetting: "Paramètres de notification d'état du véhicule",
  SelectionRequiredMsg: "Sélectionnez au moins une réservation à approuver / rejeter",
  LblSelectionRequired: "Sélection requise",
  LblCollectionDate: "Date du prélèvement automatique",
  LblBICCode: "Code BIC",
  LblDirectDebitFile: "Fichier de prélèvement automatique",
  LblFormat: "Format",
  LblMissingIBANNumber: "IBAN manquant",
  LblImportDriverRole: "Attribuer automatiquement le rôle de conducteur ?",
  LblAssignToSVG: "Affecter au(x) groupe(s) du pool",
  LblSVG: "Groupe de pool",
  LblMandateId: "Id. du mandat",
  LblMandateSignatureDate: "Date de signature du mandat",
  LblIsAmmandment: "Est une modification",
  LblRemovePersonDetails: "Supprimer les données à caractère personnel",
  LblDashboard: "Tableau de bord",
  LblGroupAdmin: "Administrateur du groupe",
  LblCurrentLocation: "Emplacement actuel",
  LblCurrentDriver: "Conducteur actuel",
  LblNextDriver: "Conducteur suivant",
  LblSecond: "Seconde(s)",
  LblCleaning: "Nettoyer",
  LblRefueling: "Faire le plein / Recharger",
  LblAPKMaintenance: "Entretien CT",
  LblOutsideGeofence: "Géofence extérieure",
  LblNotBooked: "Non réservé",
  LblNotBookedSince: "Non réservé depuis",
  LblLowBattery: "Tension de la batterie faible",
  LblBatteryVolt: "V.",
  LblLowCharge: "Batterie (presque) vide",
  LblChargingPercentage: "%",
  LblOnSamePosition: "Non déplacé",
  LblLastPosition: "Dernier emplacement",
  LblNotReturn: "Non retourné",
  LblCommunicationProblem: "Problème de communication",
  LblInuse: "En cours d'utilisation",
  LblPriority: "Priorité",
  LblDirectDebitDownloadSuccess: "Fichier de prélèvement automatique téléchargé",
  LblDefaultStatus: "Statut par défaut",
  LblWarnings: "Avertissements",
  LblDirectDebitFileId: "Id du fichier de prélèvement automatique",
  LblTotalAmount: "Montant total",
  LblReCreate: "Télécharger à nouveau",
  LblPleaseEnterCollectionDate: "Saisissez date de prélèvement automatique",
  LblOpenViaLowLevel: "Low level déverrouillé",
  LblInstanceNotificationNote1: "L'institution travaille comme une institution dans l'entreprise",
  LblNoInvoiceSelected: "Aucune facture sélectionnée pour le prélèvement automatique",
  LblIBANNumberRequired: "Saisissez l'IBAN et le code BIC",
  LblNoEmptyIBANFound: "Aucun IBAN vide trouvé",
  LblShowVehicleChargeLevel: "Afficher le niveau de charge du véhicule sur le eeb et l'application ?",
  LblChargeLevel: "Niveau de charge",
  LblCharging: "Recharger",
  LblNoDataFound: "Aucune donnée disponible",
  LblOfficeStartTime: "Heures d'ouverture du bureau (hh:mm)",
  LblOfficeEndTime: "Heures de fermeture du bureau (hh:mm)",
  
  //Reports
  LblTripDataReport: "Aperçu des données des trajets",
  LblByDriver: "Sur conducteur",
  LblByVehicle: "Sur véhicule",
  LblModuleRights: "Droits du module",
  LblCostCenterReport: "Rapport sur les centres de coûts",
  LblShowTotalOnly: "Afficher le total uniquement",
  LblByOrganization: "Sur l'organisation",
  
  //Organization
  LblOrganization: "Organisation",
  LblOrganizationName: "Nom de l'organisation",
  LblOrganizationAddress: "Adresse de l'organisation",
  LblExistingDriverAddSuccessMsg: "Le conducteur a été ajouté avec succès et rattaché à l'organisation",
  LblAddDriverSuccessMsg: "Le conducteur a été ajouté et le lien d'activation lui a été envoyé avec succès.",
  LblCreateOrganization: "Créer une organisation",
  LblOrganizationDriversList: "Conducteur organisation",
  LblAddDriverToOrganization: "Ajouter conducteur à organisation",
  LblAddDriver: "Ajouter un conducteur",
  LblVatNumber: "Numéro de TVA",
  
  // Branding
  LblBranding: "Image de marque",
  LblLogo: "Logos",
  LblEmailNotificationInvoiceTemplate: "Modèles de notification et de facture par mail",
  LblExpandedWebMenu: "Menu web déplié",
  LblCollapsedWebMenu: "Menu web plié",
  LblMobileApp: "Application mobile",
  LblSplashScreen: "Écran de démarrage",
  LblWebApplication: "Application web",
  LblMobileApplication: "Application mobile",
  LblBrandingSavedSuccess: "Image de marque enregistrée",
  LblBrandingTemplateConfiguration: "Configuration image de marque & modèle",
  LblAppWebUI: "Application et interface utilisateur web",
  LblNonBookingCommunication: "Communication générale",
  LblApprovalAdminName: "Approbation de l'administrateur",
  LblBookingCommunication: "Communication concernant la réservation",
  LblInstanceBranding: "Utilisez toujours l'image de marque de l'instance",
  LblCompanyBranding: "Utilisez l'image de marque de l'entreprise si possible",
  BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Barre supérieure, menu et éléments actifs",
  BO_TOP_MENU_ACTIVE_ITEM_TEXT: "Texte des menus",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND: "Bouton en surbrillance",
  BO_HIGHLIGHTED_BUTTON_TEXT: "Texte du bouton en surbrillance",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "Bouton en surbrillance (survol)",
  BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "Texte du bouton en surbrillance (survol)",
  BO_PRIMARY_BUTTON_BACKGROUND: "Bouton principal",
  BO_PRIMARY_BUTTON_TEXT: "Texte du bouton principal",
  BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "Bouton principal (survol)",
  BO_PRIMARY_BUTTON_TEXT_HOVER: "Texte du bouton principal (survol)",
  BO_SECONDARY_BUTTON_BACKGROUND: "Bouton secondaire",
  BO_SECONDARY_BUTTON_TEXT: "Texte du bouton secondaire",
  BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "Bouton secondaire (survol)",
  BO_SECONDARY_BUTTON_TEXT_HOVER: "Texte du bouton secondaire (survol)",
  BO_HYPERLINK_TEXT: "Texte du lien hypertexte",
  BO_HIGHLIGHT_BACKGROUND: "Surligner la couleur",
  BO_HIGHLIGHT_TEXT: "Surligner le texte",
  BO_CALENDAR_EVENT_BACKGROUND: "Élément du calendrier",
  BO_CALENDAR_EVENT_TEXT: "Texte de l'élément de calendrier",
  MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Barre supérieure et menu",
  MO_LOGO_AREA_BACKGROUND: "Arrière-plan logo",
  MO_PAGE_BACKGROUND: "Arrière-plan",
  MO_MENU_TEXT: "Texte des menus",
  MO_TITLE_TEXT: "Texte du titre",
  MO_HYPERLINK_TEXT: "Texte du lien hypertexte",
  MO_ENABLED_BUTTON_BACKGROUND: "Bouton utilisable",
  MO_ENABLED_BUTTON_TEXT: "Texte de bouton utilisable",
  MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "Bouton utilisable (actif)",
  MO_ENABLED_BUTTON_TEXT_ACTIVE: "Texte du bouton utilisable (actif)",
  MO_DISABLED_BUTTON_BACKGROUND: "Bouton inutilisable",
  MO_DISABLED_BUTTON_TEXT: "Texte du bouton inutilisable",
  MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "Bouton inutilisable (actif)",
  MO_DISABLED_BUTTON_TEXT_ACTIVE: "Texte du bouton inutilisable (actif)",
  MO_HIGHLIGHT_BACKGROUND: "Couleur de surbrillance",
  MO_HIGHLIGHT_TEXT: "Texte surligné",
  MO_CALENDAR_EVENT_BACKGROUND: "Élément du calendrier",
  MO_CALENDAR_EVENT_TEXT: "Texte de l'élément de calendrier",
  LblBookingDelayConfig: "Configuration du délai de réservation",
  LblBookingDelayConfigEnabled: "Envoyer un courriel à l'administrateur",
  LblEnableSnauilTrail: "Activer Snail Trail",
  LblAppSupportTo: "Utilisation appli",
  LblNotificationInterval: "Intervalle de notification",
  LblNotifyAfterMinutes: "Notification après X minutes",
  LblMinutes: "Minutes",
  lblNotificationRecipients: "Destinataires des notifications",
  LbLEnableBookingStillRunning: "Activer la notification « Réservation non terminée »",
  LblBookingrunningNotification: "Notification de configuration Réservation non terminée",
  
  //Raise and clear settings for low battery flag
  LblDefaultVehicleSetting: "Paramètre par défaut du véhicule",
  LblLowBatteryFlagRaised: "Avertissement de batterie faible activé (tension)",
  LblLowBatteryFlagClear: "Avertissement de batterie faible effacé à (tension)",
  LblPreferableImageSize: "Taille d'image souhaitée",
  LblWebBrandingExapandImageSize: "1150px X 260px",
  LblMobileBrandingImageSize: "550px X 250px",
  LblWebBrandingCollapseImageSize: "325px X 250px",
  LblMinutesAfterBookingEndTime: "Combien de minutes après l'heure de fin de réservation ?",
  LblResendNotoficationEvery: "Renvoyer la notification toutes les minutes",
  LblByBooking: "Sur réservation",
  LblSnailTrailReport: "Rapport Snail Trail",
  LblKickbackReport: "Rapport Kickback",
  LblGroupBy: "Grouper par",
  LblTripDetail: "Détails du trajet",
  LblTripNumber: "Numéro de trajet",
  LblStart: "Début",
  LblAverageSpeed: "Vitesse moyenne",
  LblSegmentDetail: "Détail du segment",
  LblSegmentNumber: "Numéro du segment",
  LblSpeed: "Vitesse",
  LblOdometer: "Compteur kilométrique",
  LblNext: "Suivant",
  LblSegmentDetailNotAvailable: "Détail du segment non disponible",
  LblUnitPerKm: "par km",
  LblUnitPerBooking: "par résa.",
  LblBookingCostSummary: "Aperçu des coûts de réservation",
  LblTimeCost: "Coûts de temps",
  LblTotalTime: "Durée totale",
  LblTime: "Temps",
  LblCostRateUnits: "Coût (nombre * taux)",
  LblFreeTime: "Temps supplémentaire gratuit",
  LblRate: "Tarif",
  LblExVat: "HT",
  LblInclVat: "TTC",
  LblKmDriven: "Kms effectués",
  LblFreeKms: "Crédits offerts",
  LblTimePercent: "Pourcentage de temps",
  LblTotalExVat: "Total HT",
  LblTotalVat: "Total TVA",
  LblTotalInclVat: "Total TTC",
  LblKilometerCost: "Frais kilométriques",
  LblBookingApprovedSuccessMsg: "Les demandes de réservation sélectionnées ont été approuvées avec succès",
  LblBookingRejectedSuccessMsg: "Les demandes de réservation sélectionnées ont été rejetées",
  LblRejection: "Rejet",
  LblrejectionReasonMsg: "Donnez un motif pour le rejet des demandes de réservation sélectionnées",
  LblApproveConfirmationMsg: "Êtes-vous sûr de vouloir approuver toutes les demandes de réservation sélectionnées ?",
  LblFixedCost: "Coûts fixes",
  LblTotals: "Totaux",
  LblTypeDamage: "Dommages",
  LblTypeMaintenance: "Entretien CT prochainement",
  LblTypeOnSamePosition: "Véhicule plus de %0 %1 au même endroit",
  LblTypeNotBooked: "Véhicule plus de %0 %1 non réservé",
  LblTypeNotReturn: "L'heure de fin de réservation est atteinte, le véhicule n'est pas au site d'origine",
  LblBatteryVoltage: "Voltage de batterie",
  LblApprovedRejectedby: "Approuvée / rejetée par",
  LblBookingRequestList: "Liste des demandes de réservation",
  LblCannotUnsubscribe: "Impossible de se désinscrire car le chauffeur a une réservation active",
  LblPer: "Par",
  LblDateRegistered: "Date d'inscription",
  LblRegisteredBy: "Enregistré par",
  LblKMPerHour: "Km/h",
  LblMeters: "Mètres",
  LblSubscriptionEndOnBookingEnd: "Réservation en cours. Cet abonnement sera résilié lorsque la réservation sera terminée.",
  LblMarkedForDeletion: "Sélectionnée(s) pour être supprimée(s)",
  LblApplyDateFilter: "Date de l'application",
  LblNoRestriction: "AUCUNE_RESTRICTION",
  LblCustomAppTestApp: "APPLICATION_ET_TEST_PERSONNALISÉS",
  LblCustomAppOnly: "APPLICATION_PERSONNALISÉE_UNIQUEMENT",
  
  //Customer
  LblCustomer: "Client",
  LblCustomerName: "Nom du client",
  
  //Role Page
  LblRoleManagement: "rôle",
  LblRoleName: "Nom du rôle",
  LblEntityName: "Nom de l'entité",
  LblRoleType: "Type de rôle",
  LblRoleAvailability: "Disponibilité du rôle client",
  LblInternalRoleName: "Nom du rôle interne",
  LblPresentationName: "Nom de la présentation",
  LblDefaultRole: "Rôle standard",
  LblCustomRole: "Rôle client",
  LblAddRole: "Ajouter un rôle",
  LblEntity: "Entité",
  LblCopy: "Copier",
  LblAccessibilityMatrix: "Matrice d'accès",
  LblDefaultRoleModifyWarning: "La modification des droits par défaut affecte tous les utilisateurs ayant le rôle par défaut.",
  LblCopyAccessibilityMatrix: "Copier la matrice d'accès",
  LblAccess: "Accès",
  LblCustomerAdmin: "Responsable Clientèle",
  LblAdmin: "Beheerder",
  LblDoYouWantToRemove: "Voulez-vous supprimer %0 en tant que %1 ?",
  LblDoYouWantToAdd: "Voulez-vous ajouter %0 en tant que %1 ?",
  LblRoleAddedSuccess: "%0 ajouté en tant que %1",
  LblRoleDeletedSuccess: "%0 supprimé en tant que %1",
  LblInstanceAdmin: "Gestionnaire d'instances",
  LblInvitationMailSuccess: "Le mail d'invitation a été envoyé à l'adresse mail spécifiée.",
  LblInvite: "Envoyer invitation",
  LblCreateNew: "Nouvel élément",
  LblCommonErrorMessage: "Une erreur s'est produite lors du traitement de la demande. Veuillez contacter l'administrateur.",
  LblError: "Erreur",
  LblThankYouForAcceptingInvitation: "Merci d'avoir accepté l'invitation",
  LblPleaseClick: "Veuillez s'il vous plaît cliquer",
  LblHere: "ici",
  LblToLogin: "pour vous connecter",
  LblThankYouForConfirmation: "Merci pour votre confirmation",
  LblGoToHome: "Aller à la page d'accueil",
  LblInvitationSuccess: "Invitation réussie",
  LblInvitationReject: "Invitation refusée",
  
  //
  LblAssignExisting: "Attribuer droits existants",
  LblPersonProfileSuccessMessage: "Votre profil a été activé avec succès",
  LblPlease: "S'il vous plaît",
  LblLogin: "Connexion",
  
  //Branding & Template
  LblBrandingandTemplates: "Image de marque et modèles",
  LblTermsAndCondition: "Conditions générales",
  LblTermsAndConditionList: "Liste des conditions générales et déclaration de confidentialité",
  LblName: "Nom",
  LblVersion: "Version",
  LblActivityLog: "Journal de bord",
  LblAcceptance1: "Avant l'activation du compte",
  LblAcceptanceMoment: "Acceptatie moment",
  LblContents: "Contenu",
  LblIsAccept: "J'accepte",
  LblReadAndAgree: "J'ai lu et j'accepte",
  LblClose: "Fermer",
  LblTermsConditionPrivacy: "Conditions générales et déclaration de confidentialité",
  LblPrivacyStatements: "Déclarations de confidentialité",
  
  //Pre Post Trip Setting
  LblPrePostTripSetting: "Configuration des questions en début et fin de trajet",
  LblPrePostTripQuestions: "Questions avant et après le voyage",
  LblPrePostTripQuestion: "Questions avant et après le voyage",
  LblPrePostTripQuestionList: "Questionnaire début et fin du trajet",
  LblPreTripQuestion: "Questions au début du trajet",
  LblCustom: "Modifiée",
  LblPostTripQuestion: "Questions après le trajet",
  LblRequired: "Obligatoire",
  LblBeforeOpeningTheVehicle: "Avant l'ouverture du véhicule",
  LblAfterOpeningTheVehicle: "Après l'ouverture du véhicule",
  LblOrder: "Ordre",
  LblQuestion: "Question",
  LblOn: "Activée",
  LblOptional: "Facultatif",
  LblOff: "Désactivée",
  LblAnswerType: "Type de réponse",
  LblText: "Texte",
  LblYesNo: "Oui / Non",
  LblAnswer: "Réponse",
  LblTimeStamp: "Heure",
  LblFazTripQuestion: "FaZ Questions",
  LblFazTripQuestionAfterClosingTheVehicle: "Questions FaZ après la fermeture du véhicule",
  
  //Accessibility Matrix
  LG_WEB_DASHBOARD: "Tableau de bord web",
  PR_BOOKING_REQUEST: "Demande de réservation",
  LblApproveBookingRequest: "Approuver",
  LblRejectBookingRequest: "Rejeter",
  PR_DASHBOARD: "Tableau de bord",
  PR_REMOVE_DRIVER_LICENSE: "Supprimer le permis de conduire",
  PR_VEHICLE_FUTURE_BOOKINGS: "Réservations futures du véhicule",
  PR_INSTANCE: "Instance",
  PR_BRANDING: "Image de marque",
  PR_PERSON_OVERVIEW: "Aperçu des personnes",
  PR_WEGO_ADMINS: "Admins WeGo",
  PR_COMPANY_OVERVIEW: "Aperçu de l'entreprise",
  PR_CONTACT_PERSON: "Personne de contact",
  PR_COMPANY_ADMIN: "Administrateur d'entreprise",
  PR_COMPANY_VEHICLE_OVERVIEW: "Aperçu des véhicules de l'entreprise",
  PR_COMPANY_SVG_OVERVIEW: "Aperçu des groupes de pools de l'entreprise",
  PR_ORGANIZATION_OVERVIEW: "Aperçu de l'organisation",
  PR_ORGANIZATION_CONTACT_PERSON: "Personne de contact de l'organisation",
  PR_ORGANIZATION_ADMIN_OVERVIEW: "Aperçu de l'administrateur de l'organisation",
  PR_ORGANIZATION_DRIVER_OVERVIEW: "Aperçu des conducteurs de l'organisation",
  PR_SHARED_VEHICLE_GROUP_OVERVIEW: "Aperçu des groupes de pools",
  PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: "Aperçu de l'administrateur des groupes de pools",
  PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW: "Aperçu des véhicules des groupes de pools",
  PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW: "Aperçu des conducteurs des groupes de pools",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW: "Aperçu du groupe de type de contrat des groupes de pools",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW: "Aperçu du type de contrat des groupes de pools",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Aperçu des abonnements de groupes de pools",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW: "Aperçu des disponibilités des abonnements de groupes de pools",
  PR_SPECIAL_PERIODS: "Périodes particulières",
  PR_VEHICLES_OVERVIEW: "Aperçu des véhicules",
  PR_VEHICLE_SVG_OVERVIEW: "Aperçu des groupes de pools de véhicules",
  PR_VTS_VEHICLE_LIST: "VTS Vehicle List",
  PR_VTS_TROUBLESHOOT: "VTS Troubleshoot",
  PR_VEHICLE_ATTRIBUTE_CATEGORIES: "Catégories de caractéristiques des véhicules",
  PR_VEHICLE_ATTRIBUTE: "Caractéristiques des véhicules",
  PR_ODOMETER_LOG_TRAIL: "Journal de bord du compteur kilométrique",
  PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "Journal de bord du compteur kilométrique Enregistré par",
  PR_DRIVER_OVERVIEW: "Aperçu du conducteur",
  PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW: "Aperçu des conducteurs du groupe de pools",
  PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Overzicht van de abonnementen voor de conducteurs de groupes de pools",
  PR_BOOKINGS_OVERVIEW: "Aperçu des réservations",
  PR_NORMAL_BOOKING: "Nouvelle réservation",
  PR_SPECIAL_BOOKING: "Réservation particulière",
  PR_TRIP_SIMULATOR: "Simulateur de trajet",
  PR_INVOICE: "Facture",
  PR_DIRECT_DEBIT_FILE: "Fichier de prélèvement automatique",
  PR_ADDITIONAL_FREE_ITEMS: "Éléments supplémentaires gratuits",
  PR_TEST_INVOICE_GENERATOR: "Générateur de facture test",
  PR_VEHICLE_OCCUPANCY_REPORT: "Rapport d'occupation du véhicule",
  PR_REVENUE_PER_VEHICLE_REPORT: "Rapport de revenus par véhicule",
  PR_TRIP_DATA_REPORT: "Rapport de données de trajet",
  PR_MAINTENANCE_PLANNING_REPORT: "Rapport de planification de l'entretien",
  PR_SANIL_TRAIL_REPORT: "Rapport Snail Trail",
  PR_KICKBACK_REPORT: "Rapport Kickback",
  PR_INVOICE_PAYMENT_HISTORY: "Historique de paiement des factures",
  PR_TEMPLATES: "Modèles",
  PR_SIGNUP_FORMS_OVERVIEW: "Aperçu des formulaires d'inscription",
  PR_SIGNUPS_OVERVIEW: "Aperçu des inscriptions",
  PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "Aperçu des inscriptions pour le formulaire d'inscription",
  PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP: "Aperçu des inscriptions au groupe de pool",
  PR_EVENT_VIEWER: "Aperçu des événements",
  PR_USER_PROFILE: "Profil de l'utilisateur",
  PR_PRE_POST_TRIP_SETTING: "Paramètres questions de début et de fin de trajet",
  PR_PRE_POST_TRIP_QUESTIONS: "Aperçu des questions de début et de fin de trajet",
  PR_TERMS_AND_CONDITION: "Règles et conditions",
  PR_PREPOST_TRIP_QUESTIONS_UPDATE: "Questions de début et de fin de trajet",
  LG_CUSTOMER: "Client",
  LG_INSTANCE: "Instance",
  LG_BRANDING: "Image de marque",
  LG_PERSON: "Personne",
  LG_COMPANY: "Société",
  LG_ORGANIZATION: "Organisation",
  LG_SHARED_VEHICLE_GROUP: "Groupe de véhicules partagés",
  LG_VEHICLE: "Véhicule",
  LG_DRIVER: "Conducteur",
  LG_BOOKING: "Réservation",
  LG_INVOICE: "Facture",
  LG_REPORT: "Rapport",
  LG_TEMPLATE: "Modèle",
  LG_SIGNUP_FORM: "Formulaire d'inscription",
  LG_EVENT_VIEWER: "Observateur d'événements",
  LG_PRE_POST_TRIP_SETTING: "Paramètres questions de début et de fin de trajet",
  LG_USER: "Utilisateur",
  LG_BRANDING_AND_TEMPLATE: "Image de marque & modèles",
  LG_PREPOSTTRIPQUESTION: "Questions de début et de fin de trajet",
  PR_RESET_ADMIN_COOKIES: "Supprimer les cookies admin",
  PR_RESET_ADMIN_TWOFA: "Supprimer les cookies d'authentification à deux facteurs",
  LG_REPORTINGTOOL: "Application de reporting",
  PR_BOOKING_OVERVIEW: "Aperçu de la réservation",
  PR_ROB_NOTIFICATIONS: "Aperçu du ROB",
  PR_MILEAGE_OVERVIEW: "Aperçu du kilométrage",
  PR_USAGE_OVERVIEW: "Nombre de jours non utilisés",
  PR_POSITION_ON_MAP: "Position sur la carte",
  PR_VEHICLE_ON_LOCATION_MAP: "Véhicule sur site",
  PR_TRIP_OVERVIEW: "Enregistrement des trajets",
  PR_ALTERNATE_TRANSPORTATION: "Véhicule de remplacement",
  PR_AVERAGE_OVERVIEW: "Aperçu des moyennes",
  PR_PRE_POST_BOOKING_OVERVIEW: "Questions avant/après par aperçu de réservation",
  PR_HOME_LOCATIONS_OVERVIEW: "Vue d'ensemble des emplacements d'accueil des véhicules et des SVG",
  
  //Vat Setting
  LblVatSettings: "Paramètres de TVA",
  LblVatPercentages: "Pourcentages de TVA",
  LblDefaultCost: "Afficher et modifier les coûts standard",
  LblExcludingVat: "HT",
  LblIncludingVat: "TTC",
  LblVatEnterDescription: "Saisir description",
  LblEnterVatPercentage: "Saisir % TVA",
  LblVatPercentageError: "Veuillez saisir un pourcentage valide",
  LblVatDescriptionError: "Veuillez saisir une description valide",
  LblStartDate: "Date de début",
  LblVatEndDate: "Date de fin",
  LblVatDeleteConfirmation: "Êtes-vous sûr de vouloir fixer la date de fin de la TVA ?",
  LblVatEndDateError: "Veuillez indiquer la date de fin de la TVA",
  LblVatEndDateNote: "Note : les données seront exclues à partir de la date sélectionnée.",
  LblVatStartDate: "Date de début",
  LblVatStartDateError: "Veuillez sélectionner la date de début",
  
  //Accessibility Matrix
  LG_ROLE: "Rôle",
  PR_CUSTOMER_ADMIN_OVERVIEW: "Aperçu admin clients",
  PR_INSTANCE_ADMIN_OVERVIEW: "Aperçu administrateur instance",
  PR_ROLE_OVERVIEW: "Rôle",
  PR_ROLE_ASSIGN: "Attribuer un rôle",
  PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE: "Groupe de pool actif ou inactif",
  PR_CUSTOMER_OVERVIEW: "Client",
  PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "Aperçu de l'abonnement de l'organisation",
  PR_VTS_VEHICLE_EVENT_HISTORY: "Historique des événements du véhicule VTS",
  PR_BATCH_UPLOAD_PERSON: "Téléchargement par lots de personnes",
  PR_IMPORT_PERSON: "Importer la personne",
  PR_PRE_POST_TRIP_QUESTION_UPDATE: "Questions de début et de fin de trajet",
  LblPrivacyErrorMessage: "Vous n'êtes pas autorisé à consulter cette page",
  LblPrivacyNavigate: "Veuillez naviguer vers",
  LblPrivacyError: "Erreur de confidentialité",
  LblLinkExpired: "Lien expiré",
  LblLinkExpiredMessage: "Le lien a expiré et ne peut plus être utilisé. Veuillez réessayer.",
  LblBearer: "Centre de coûts",
  LblWhoBenifitFreeItem: "À qui profitent les crédits d’abonnement?",
  LblNoDistinction: "Par défaut (aucune distinction)",
  LblPenaltyVat: "TVA pénalité",
  LblTimeRateVat: "TVA taux horaire",
  LblMileageRateVat: "TVA prix kilométrique",
  LblFixedFeeVat: "TVA sur les coûts fixes",
  LblSendInvoiceToOrganization: "Envoyer la facture à l'organisation",
  LblExpenseAmountVat: "TVA dépenses",
  LblDefaultVatContractTypeGroupCost: "TVA% pour les coûts du groupe de type de contrat",
  LblDefaultVatContractTypeCost: "TVA% pour les coûts du groupe",
  LblDefaultVatSubscriptionCost: "TVA % pour les frais d'abonnement",
  LblPenaltyCost: "Frais de pénalité",
  LblTimeRates: "Tarifs horaires",
  LblDistanceRates: "Tarifs distance",
  LblFixedRates: "Tarifs fixes",
  LblSubscriptionCost: "Frais d'abonnement",
  
  // template
  LblEmailTemplate: "Modèle mail",
  LblWebTemplate: "Modèle web",
  LblEmailAddressesEntryPattern: "Adresses mail séparées par des virgules (comme ex1@ex.com, ex2@ex.com)",
  LblNoRecipientWarning: "Aucun destinataire applicable. Les destinataires par défaut seront les destinataires de ce modèle.",
  
  //MobileApp Configuration
  LblMobileAppConfiguration: "Configuration de l'application mobile",
  LblEnableNewBooking: "Activer nouvelle réservation",
  LblEnableBookingCalender: "Activer le calendrier de réservation",
  LblEnableSubscription: "Activer abonnement",
  LblEnableUpdateProfile: "Activer « Mettre à jour le profil »",
  LblEnableNotification: "Activer les notifications",
  LblEnableChangeBooking: "Activer « Modifier la réservation »",
  LblEnableAddExpenseMenu: "Activer le menu « Ajouter des dépenses »",
  LblChamberOfCommerce: "Chambre de commerce",
  LblInvoicingSettings: "Paramètres de facturation",
  LblInvoiceSender: "Expéditeur de la facture",
  LblCostAndExpenses: "Coûts et dépenses",
  LblSender: "Expéditeur",
  LblAddressee: "Destinataire",
  LblAddLine: "Ajouter une ligne",
  LblSaveInvoice: "Enregistrer la facture",
  LblVatAmount: "Montant de la TVA",
  LblBookingId: "ID de la réservation",
  LblReceiptOrSuppor: "Bon ou soutien",
  LblVATPercentage: "TVA (%)",
  LblChargeTo: "Facturer",
  LblReimburseTo: "Rembourser à",
  LblReportedBy: "Signalé par",
  LblReportedAmount: "Quantité déclarée",
  LblApprovedAmount: "Montant autorisé",
  LblCostType: "Type de coût",
  LblRecipient: "Destinataire",
  LblCostDetail: "Détail des coûts",
  LblAddExisting: "Ajouter frais mentionnés précédemment",
  LblReceiptOrSupport: "Bon ou soutien",
  LblManualInvoiceLine: "Ligne de facture manuelle",
  LblInvoiceLine: "Ligne de facture",
  LblInvoice: "Facture",
  LblInvoiceLines: "Lignes de facture",
  LblSendInvoice: "Envoyer la facture",
  LblInvoiceSent: "Facture envoyée",
  LblAddNewInvoiceLine: "Ajouter une nouvelle ligne de facture",
  LblSelectUnprocessedExpenses: "Sélectionnez une dépense non traitée",
  LblSelectAtLeastOneExpense: "Sélectionnez au moins une dépense",
  LblInvoicePaymentHistory: "Historique des paiements des factures",
  LblPaymentMode: "Méthode de paiement",
  LblLogTime: "Temps de connexion",
  PR_COST_EXPENSES: "Coûts et dépenses",
  PR_COST_CENTER_REPORT: "Rapport sur les centres de coûts",
  LblInactiveAfterDays: "Inactif après (jours)",
  LblMarkDeleteAfterDays: "Marquer Supprimer après (jours)",
  LblNotifyAdminBeforeDays: "Informer l'administrateur X jours auparavant",
  LblGdprSettings: "Paramètres GDPR",
  LblRemovalDate: "Date de suppression",
  LblRemovePersonOn: "Supprimer la personne le",
  LblNoPaymentLinkGenerated: "Aucun lien de paiement généré",
  
  //Payment Module
  LblPaymentConfig: "Configuration des paiements",
  LblPaymentConfigButton: "Configuration des paiements",
  LblPaymentProvider: "Prestataire de services de paiement",
  LblCountry: "Pays",
  LblEmailAddress: "Adresse mail",
  LblAllowPaymentConfiguration: "Autoriser la configuration des paiements",
  LblAllowPayment: "Autoriser le paiement",
  LblPaymentSetting: "Paramètres du prestataire de services de paiement",
  LblEnvironment: "Environnement",
  LblInvoicePaymentTermDays: "Délai de paiement de la facture (jours)",
  LblLinkValidityDays: "Période de validité du lien (jours)",
  LblReportedOn: "Signalé le",
  LblPaymentMethods: "Méthodes de paiement",
  LblPaymentProviderSecretKey: "Clé secrète PSP",
  LblPaymentProviderUsername: "Nom d'utilisateur PSP (clé)",
  LblCreditCardPayment: "Paiement par carte de crédit",
  LblInitialPayment: "Acompte",
  LblCreateBookingPayment: "Créer un paiement de réservation",
  LblStartBookingPayment: "Commencer à réserver Paiement",
  LblPaymentLink: "Lien pour le paiement",
  LblPaymentHistory: "Historique des paiements",
  LblReasonOrganization: "Motif du blocage de l'organisation",
  LblDueDateUpdateSuccess: "Date d'expiration mise à jour avec succès",
  LblDueDateRequiredError: "Sélectionnez la date d'expiration.",
  LblDueDate: "Date d'expiration",
  LblConfirmDuedatechange: "Êtes-vous sûr de vouloir mettre à jour la date d'expiration ?",
  LblConfirmCloseInvoice: "Êtes-vous sûr de vouloir fermer la facture ?",
  LblConfirmReOpenInvoice: "Êtes-vous sûr de vouloir rouvrir la facture ?",
  LblInvoiceOpenCloseSuccess: "%0 de la facture avec succès",
  LblReOpen: "Rouvrir",
  LblClosed: "Clôturée",
  LblReOpenClose: "Ouvrir / fermer à nouveau",
  PR_PAYMENT_HISTORY_LIST: "Historique des paiements",
  LblUserBlockMessage: "Motif de suspension de l'utilisateur",
  PR_BLOCK_UNBLOCK_ORGANIZATION: "Bloquer / débloquer l'organisation",
  LblWhenOpeningAppAndRepeat: "Lorsque vous ouvrez l'application pour la première fois et répétez chaque ",
  LblEveryTimeOpenApp: "Chaque fois que l'on ouvre l'application",
  LblWhenMakeBooking: "Lors de la création d'une réservation",
  LblWhenStartBooking: "Lors du commencement d'une réservation",
  LblWhenOpenBooking: "Lors de l'ouverture d'un véhicule",
  LblSelectContractTypeGroup: "Lors du choix d'un ou de plusieurs groupes spécifiques de types de contrats ",
  LblDays: "Jours",
  LblNewVersion: "Nouvelle version",
  LblAction: "Action",
  LblTAndCName: "Nom CG",
  LblOldVersion: "Ancienne version",
  LblSureToRevoke: "Êtes-vous sûr de vouloir annuler %0 ?",
  LblCurrencyConfiguration: "Configuration de la devise",
  LblNameSingular: "Nom singulier",
  
  //Special Period
  LblRegularBooking: "Réservation normale",
  LblSpecialRate: "Tarif spécial",
  LblFirstDay: "Premier jour",
  LblLastDay: "Dernier jour",
  LblWeekEndContaining: "Week-end avec",
  LblNamePlural: "Nom pluriel",
  LblSignBeforeAmount: "Symbole de devise avant le montant",
  LblOutOf: "hors",
  
  //Credit card payment
  LblCrediCardPayment: "Paiement par carte de crédit",
  LblFirstBooking: "Première réservation",
  LblAllowRecurringPayment: "Autoriser la carte de crédit",
  LblProceed: "Continuer",
  LblCheckAllowPayment: "Vérifiez s'il est possible d'effectuer un versement périodique",
  LblPaymentFailed: "Autoriser la carte de crédit",
  LblPaymentSuccess: "Autorisation accordée",
  LblPaymentFailure: "Erreur d'autorisation",
  LblCompletedSuccess: "Votre autorisation a été traitée avec succès",
  LblCompletedFailure: "Votre autorisation a échoué. Veuillez revenir en arrière et réessayer.",
  LblCreditCardNumber: "Numéro de carte de crédit",
  LblCreditCardExpirationDate: "Date d'expiration Carte de crédit",
  LblCreditCardDetails: "Détails Carte de crédit",
  LblMakePayment: "Autoriser la carte de crédit",
  LblAdminPaymentConfirmation: "Il n'y a pas d'autorisation active ou un paiement a échoué. Souhaitez-vous continuer ?",
  LblPaymentDescription: "Pour réserver un véhicule, un paiement de vérification de 0 % est requis. En outre, une autorisation est nécessaire pour déduire les paiements futurs de votre carte de crédit. Les paiements sont traités par notre prestataire de paiement Buckaroo. Vous serez dirigé vers le site web de Buckaroo pour le paiement effectif. ",
  LblPay: "Payer",
  
  // NIF Number
  LblEnableNIFNumber: "Activer numéro NIF",
  LblNIFNumber: "Numéro NIF",
  LblWeGoDefault: "WeGo Standard",
  LblPersonActiveSuccess: "Personne activée avec succès",
  LblActivate: "Activer",
  LblInActiveReason: "Motif d'inactivité",
  LblDefaultLanguage: "Langue standard",
  LblRestoreInheritConfirmation: "Les paramètres actuels seront remplacés par les paramètres adoptés. Êtes-vous sûr de vouloir procéder ?",
  LblQestionTextRequired: "Texte avec question obligatoire",
  LblManualSecretKey: "Clé confidentielle",
  
  // Two Factor Authentication
  LblTwoFaConfig: "Authentification à deux facteurs",
  LblEnableTwoFa: "Activez l'authentification à deux facteurs",
  LblExpirationDays: "Dates d'expiration",
  LblTextBoxExpirationDays: "Dates d'expiration",
  Lbl2FactorAuthenticateExpDays: "Durée d'expiration du 2FA (jours) :",
  LblResetCookiesWegoAdmin: "Réinitialiser les cookies pour tous les administrateurs de WeGo",
  LblReset2FactorAuthWegoAdmin: "Réinitialiser le 2FA pour tous les administrateurs de WeGo",
  LblAuthentication: "Authentification",
  LblResetCookiesForAllAdmin: "Réinitialiser les cookies pour tous les administrateurs",
  LblReset2FaForAllAdmin: "Réinitialiser le 2FA pour tous les administrateurs",
  LblEnterTotp: "Veuillez saisir le code",
  LblEnterOtp: "Veuillez saisir le code",
  LblSubmit: "Envoyer",
  LblKeyResetSuccess: "La clé 2FA a été réinitialisée",
  LblKeyResetFailed: "Échec de la réinitialisation de la clé 2FA",
  LblCookieResetSuccess: "Les cookies 2FA ont été réinitialisés",
  LblCookieResetFailed: "Échec de la réinitialisation des cookies 2FA",
  LblGoogleAuthenticator: "Application Google Authenticator",
  LblEmailOtpSent: "Un code a été envoyé à votre adresse mail enregistrée",
  LblContinue: "Continuer",
  LblInvalidTOTP: "Ongeldige code",
  LblResetCookie: "Réinitialiser le cookie",
  LblResetTwoFA: "Réinitialiser le 2FA",
  LblDisableTwoFA: "Schakel 2FA uit",
  LblTwoFaMethod: "2FA methode",
  LblEmailAuthentication: "Authentification par mail",
  LblTwoFaMethodSelect: "Vous devez vérifier votre identité une fois de plus. Veuillez sélectionner votre méthode 2FA",
  LblMissingInvoiceGenerator: "Générateur de factures manquantes",
  LblInvoicePreFix: "Préfixe de numéro de facture",
  LblEngineStillRunning: "Commande de verrouillage envoyée alorsque le moteur tourne",
  LblMobileAppLink: "Lien vers l'application mobile",
  
  // License Check Configuration
  LblLicenseCheckConfiguration: "Configuration de la vérification du permis de conduire",
  LblValidateLicenseCheckForBooking: "Contrôler avant réservation",
  
  // Access Cards Enabled SVG
  LblAccessCardsEnabled: "Utilisation de la carte d'accès",

  // Track & Trace
  LblTrackAndTrace: "Track & Trace",
  LblRfidTagId: "RFID Tag ID",
  LblEmployeeNumber: "Numéro d'employé",
  
  // Access Card
  LblAccessCardId: "Access Card ID",

  LblDriversLicenseAndCertificates: "Certificats et permis de conduire du conducteur",
  LblLicense: "Permis de conduire du conducteur",
  LblCertificates: "Certificats",

  LblTrips: "Voyages",
  LblCostsSummary: "Résumé des coûts",
  LblStartBooking: "Commencer à réserver",
  LblStopBooking: "Arrêter la réservation",

  LblTripHistory: "Historique de trajet",
  LblTripStartDateTime : "À partir",
  LblTripEndDateTime: "À",
  LblFaZTripQuestions: "Questions FaZ",
  LblNoQuestionsFound: "Aucune question FaZ trouvée.",
  LblNoTripsFound: "Aucun trajet trouvé.",
  LblUnansweredQuestions: "Questions sans réponse",
  LblTripDetails: "Détails du trajet",
  LblNoUnansweredQuestions: "Aucune question sans réponse",
  LblAnswerSaved: "La réponse est enregistrée avec succès",
  LblAnswerSavedError: "La réponse n'a pas pu être enregistrée. Veuillez contacter l'administrateur",
  LblAnswerEmptyError: "Veuillez entrer une réponse valide",

  BtnAddVehicleInfo: "Afficher le journal vts",
  LblLoginError: "Une erreur inconnue s'est produite lors de la connexion",
  LblLoginCredentialsError: "Ce nom d'utilisateur ou mot de passe est incorrect, veuillez vérifier et réessayer",
  LblInfo: "Informations",

  ValidatePhoneNumberVts: "Veuillez saisir un numéro de téléphone valide (par exemple, +31623456789)",
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/translate/lang-fr.ts